import React, { useState } from "react";
import { Button } from "Components/Button";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import styles from "Styles/components/PrivacySend.module.css";

const PrivacySendFormContent = ({
  submitCB = () => {},
  isSubmitting = false,
}) => {
  const [isConsented, setIsConsented] = useState(false);

  const handleConsentChange = (e) => {
    setIsConsented(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isConsented && !isSubmitting) {
      if (typeof window.fbq === "function") {
        window.fbq("track", "SubmitApplication");
      }
      submitCB();
    }
  };

  return (
    <InfoContentMotionWrapper>
      <div className={styles.wrapper}>
        <form onSubmit={handleSubmit}>
          <p className={styles.introText}>
            這份初步分析將協助你快速釐清目前的行銷現況，讓你對 2026
            的布局方向更有頭緒。
          </p>
          <p className={styles.introText}>
            報告將同步發送至你的電子信箱，方便隨時查閱。
          </p>

          <div className={styles.policyBox}>
            <p className={styles.policyText}>
              Hububble
              致力於保護和尊重您的個人資料。我們將使用您的個人資料來管理您的帳戶，並提供您所需的產品和服務。我們也會不定時發送最新的產品資訊及講座活動，並提供您可能感興趣的其他內容。
            </p>

            <label className={styles.consentLabel}>
              <input
                type="checkbox"
                checked={isConsented}
                onChange={handleConsentChange}
              />
              <span>
                我同意收取來自 Hububble 的其他通訊
                <span className={styles.requiredMark}>*</span>
              </span>
            </label>

            <p className={styles.disclaimerText}>
              按下提交，即表示你同意 Hububble
              儲存並處理你提供的個人資訊，以提供你所要求的內容。
            </p>
          </div>

          <Button
            disabled={!isConsented || isSubmitting}
            type="action"
            submit
            className={styles.submitButton}
          >
            {isSubmitting ? "處理中..." : "查看我的行銷盤點總覽"}
          </Button>
        </form>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default PrivacySendFormContent;
